import mergeDeep from '@/utils/merge-deep';
import { SectionOneColumnThemeControls } from '@/components/organisms/SectionOneColumn/theming';

import block from './block.json';

export const SectionCardsEventThemeControls: ThemeControlsType = mergeDeep(
	SectionOneColumnThemeControls,
	{
		// What's displayed
		title: block.title,

		// Unique string/id of the block (= the key used in theme.json)
		slug: block.slug,
	}
);
